export const COURSE_DATA = [
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 1",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 2",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 3",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 4",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 5",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 6",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 7",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 8",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 9",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 10",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 11",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
  {
    image: "http://simpleicon.com/wp-content/uploads/picture.png",
    title: "Pelatihan 12",
    tanggal_regis: "XX-XX-2022",
    kuota_peserta: "XXX",
  },
];
